import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from './header/header.module';
import { FormsModule } from '@angular/forms';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { ContratoTransportadoraFormDialogComponent } from './app/home/contrato_transportadora/contrato-transportadora-form-dialog.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AtualizarComponent } from './atualizar/atualizar.component';
import { ContratoTransportadoraComponent } from './contrato-transportadora/contrato-transportadora.component';
// import { FormularioLocaisComponent } from './formulario_locais/formulario_locais';
import { MilkRunSulComponent } from './milk_run_sul/milk_run_sul.component';
import { CarrierComponent } from './carriers/carriers.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { CarregaJettaComponent } from './carrega-jetta/carrega-jetta.component';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { FornecedoresComponent } from './fornecedores/fornecedores.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FeatherModule } from 'angular-feather';
import { allIcons  } from 'angular-feather/icons';
import { MilkRunSPComponent } from './milk-run-sp/milk-run-sp.component';
import { MilkRunARGComponent } from './milk-run-arg/milk-run-arg.component';
import { InterplantasComponent } from './interplantas/interplantas.component';
import { TimeTableComponent } from './timetable/timetable.component';
import { LocaisComponent } from './locais/locais.component';
import { MatInputModule } from '@angular/material/input';
import { VeiculosLabComponent } from './veiculos-lab/veiculos-lab.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { VeiculosFormDialogComponent } from './app/home/veiculos/veiculos-form-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { ClarityModule } from '@clr/angular';
import { TrackingComponent } from './tracking/tracking.component';
import { ContratoTerrestreFormDialogComponent } from './app/home/contrato_terrestre/contrato-terrestre-form-dialog.component';
import { ExtraRequestComponent } from './app/home/extra-request/extra-request.component';
import { ExtraFreightComponent } from './extra-freight/extra-freight.component';
import { LoginComponent } from './login/login.component';
import { SharedModule } from './shared/shared.module';
import { CadastroComponent } from './cadastro/cadastro.component';
import { CadastroCarriersComponent } from './cadastro-carriers/cadastro-carriers.component';
import { CadastroContratosComponent } from './cadastro-contratos/cadastro-contratos.component';
import { CadastroUsersComponent } from './cadastro-users/cadastro-users.component';
import { CustomDatePipe } from './relatorios/custom-data-pipe';
import { VwAtualizaComponent } from './vw-atualiza/vw-atualiza.component';
import { VwOperacaoComponent } from './vw-operacao/vw-operacao.component';
import { VwTrackingComponent } from './vw-tracking/vw-tracking.component';
import { ControlCenterOriComponent } from './control-center-ori/control-center-ori.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TipoVeiculosComponent } from './tipo-veiculos/tipo-veiculos.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';
import { CarregaJettaTCMComponent } from './carrega-jetta-tcm/carrega-jetta-tcm.component';
import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt';
import { PainelInfoComponent } from './painel-info/painel-info.component';
registerLocaleData(localePT);
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerComponent } from './spinner/spinner.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { RelatorioInterplantasComponent } from './relatorio-interplantas/relatorio-interplantas.component';
import { CarregaJettaTcmSpComponent } from './carrega-jetta-tcm-sp/carrega-jetta-tcm-sp.component';
import { ExtraFreightConcludedComponent } from './extra-freight-concluded/extra-freight-concluded.component';
// import { TimeTableMilkRunComponent } from './time-table/time-table.component';
// import { GridTileComponent } from './grid-tile/grid-tile.component';
import { RelatorioInterplantasPreenchidoComponent } from './relatorio-interplantas-preenchido/relatorio-interplantas-preenchido.component';
import { TimeTableModelComponent } from './time-table-model/time-table-model.component';
import { MilkRunArgEmbalagemComponent } from './milk-run-arg-embalagem/milk-run-arg-embalagem.component';
import { TimeTableInterplantasComponent } from './time-table-interplantas/time-table-interplantas.component';
import { RelatorioInterplantasAutomaticoComponent } from './relatorio-interplantas-automatico/relatorio-interplantas-automatico.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { HomeComponent } from './home/home.component';
import { HoraInputComponent } from './hora-input/hora-input.component';
import { NovoFornecedorFreteExtraComponent } from './novo-fornecedor-frete-extra/novo-fornecedor-frete-extra.component';
import { ContainerFlowComponent } from './container-flow/container-flow.component';
import { UploadExcelContainerComponent } from './upload-excel-container/upload-excel-container.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DiretosFlowComponent } from './diretos-flow/diretos-flow.component';
import { DetalhesContainerComponent } from './detalhes-container/detalhes-container.component';
import { UploadExcelDiretosComponent } from './upload-excel-diretos/upload-excel-diretos.component';
import { PlanilhaInputDiretosComponent } from './planilha-input-diretos/planilha-input-diretos.component';
import { PlanilhaInputDiretosExtraComponent } from './planilha-input-diretos-extra/planilha-input-diretos-extra.component';
import { PlanilhaInputDiretosLcbExtraComponent } from './planilha-input-diretos-lcb-extra/planilha-input-diretos-lcb-extra.component';
import { PlanilhaInputDiretosLcbComponent } from './planilha-input-diretos-lcb/planilha-input-diretos-lcb.component';
import { ContainerDtaComponent } from './container-dta/container-dta.component';
import { KPISotifComponent } from './kpi-sotif/kpi-sotif.component';
import { ContainerLCPneusComponent } from './container-lc-pneus/container-lc-pneus.component';
import { TimeTableScaniaComponent } from './time-table-scania/time-table-scania.component';
import { ContainerExpComponent } from './container-exp/container-exp.component';
import { UploadExcelContainerExpComponent } from './upload-excel-container-exp/upload-excel-container-exp.component';
import { PrevisaoLCBComponent } from './previsao-lcb/previsao-lcb.component';
import { CarregaJettaInterplantasComponent } from './carrega-jetta-interplantas/carrega-jetta-interplantas.component';
import { OcupacaoTrucksComponent } from './ocupacao-trucks/ocupacao-trucks.component';
import { NgChartsModule } from 'ng2-charts';
import { GraficoOcupacaoComponent } from './grafico-ocupacao/grafico-ocupacao.component';
import { TimeTableSESEComponent } from './time-table-sese/time-table-sese.component';
import { TimeTableExpedicaoComponent } from './time-table-expedicao/time-table-expedicao.component';
import { NewTimeTableOutllok2Component } from './new-time-table-outllok2/new-time-table-outllok2.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { VwTrackingNewComponent } from './vw-tracking-new/vw-tracking-new.component';
import { VwOperacaoJSLItaquaComponent } from './vw-operacao-jslitaqua/vw-operacao-jslitaqua.component';
import { VwOperacaoTCMComponent } from './vw-operacao-tcm/vw-operacao-tcm.component';
import { VwOperacaoSESEComponent } from './vw-operacao-sese/vw-operacao-sese.component';
import { VwOperacaoTCMSBCComponent } from './vw-operacao-tcmsbc/vw-operacao-tcmsbc.component';

@NgModule({ declarations: [
        AppComponent,
        FornecedoresComponent,
        ContratoTransportadoraFormDialogComponent,
        AtualizarComponent,
        DashboardComponent,
        ContratoTransportadoraComponent,
        LoginComponent,
        VeiculosFormDialogComponent,
        CadastroComponent,
        // FormularioLocaisComponent,
        ExtraRequestComponent,
        ExtraFreightComponent,
        ContratoTerrestreFormDialogComponent,
        MilkRunSulComponent,
        CarrierComponent,
        CarregaJettaComponent,
        MilkRunSPComponent,
        MilkRunARGComponent,
        InterplantasComponent,
        TimeTableComponent,
        LocaisComponent,
        VeiculosLabComponent,
        TrackingComponent,
        CadastroCarriersComponent,
        CadastroContratosComponent,
        CadastroUsersComponent,
        CustomDatePipe,
        VwAtualizaComponent,
        VwOperacaoComponent,
        VwTrackingComponent,
        ControlCenterOriComponent,
        TipoVeiculosComponent,
        RelatoriosComponent,
        CarregaJettaTCMComponent,
        PainelInfoComponent,
        SpinnerComponent,
        RelatorioInterplantasComponent,
        CarregaJettaTcmSpComponent,
        ExtraFreightConcludedComponent,
        // TimeTableMilkRunComponent,
        // GridTileComponent,
        RelatorioInterplantasPreenchidoComponent,
        TimeTableModelComponent,
        MilkRunArgEmbalagemComponent,
        TimeTableInterplantasComponent,
        RelatorioInterplantasAutomaticoComponent,
        UnauthorizedComponent,
        HomeComponent,
        HoraInputComponent,
        NovoFornecedorFreteExtraComponent,
        ContainerFlowComponent,
        UploadExcelContainerComponent,
        DiretosFlowComponent,
        DetalhesContainerComponent,
        UploadExcelDiretosComponent,
        PlanilhaInputDiretosComponent,
        PlanilhaInputDiretosExtraComponent,
        PlanilhaInputDiretosLcbExtraComponent,
        PlanilhaInputDiretosLcbComponent,
        ContainerDtaComponent,
        KPISotifComponent,
        ContainerLCPneusComponent,
        TimeTableScaniaComponent,
        ContainerExpComponent,
        UploadExcelContainerExpComponent,
        PrevisaoLCBComponent,
        CarregaJettaInterplantasComponent,
        OcupacaoTrucksComponent,
        GraficoOcupacaoComponent,
        TimeTableSESEComponent,
        TimeTableExpedicaoComponent,
        NewTimeTableOutllok2Component,
        VwTrackingNewComponent,
        VwOperacaoJSLItaquaComponent,
        VwOperacaoTCMComponent,
        VwOperacaoSESEComponent,
        VwOperacaoTCMSBCComponent
    ],
    exports: [
        FeatherModule
    ],
    bootstrap: [
        AppComponent
    ], 
    imports: [
        AppRoutingModule,
        MatIconModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        ClarityModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FeatherModule.pick(allIcons),
        FormsModule,
        MatFormFieldModule,
        HeaderModule,
        HighchartsChartModule,
        MatDialogModule,
        MatInputModule,
        BrowserModule,
        ProgressbarModule.forRoot(),
        NgxPaginationModule,
        FlexLayoutModule,
        MatCardModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        NgIf,
        MatSliderModule,
        TooltipModule.forRoot(),
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgChartsModule,
        ButtonModule,
        CalendarModule,
        IconFieldModule,
        InputIconModule
        // NgxMatTimepickerModule
    ],
     providers: [DatePipe, { provide: MatDialogRef, useValue: {} }, provideHttpClient(withInterceptorsFromDi()),provideAnimationsAsync()] 
    })
export class AppModule { }
